import React, { useCallback, useState } from 'react';
import Toggle from '../utils/Toggle';
import './FlowLayoutToggle.css';

// Dev-only experiment: the generator without its panels — a sticky build on
// the left, stats/spells/boosts as plain stacked sections on the right.
// `npm start` only; production builds never see the switch or the layout.
export const FLOW_LAYOUT_AVAILABLE = process.env.NODE_ENV === 'development';
const STORAGE_KEY = 'dofgen.dev.generatorFlowLayout';
const VALUE_PANELS = 'panels';
const VALUE_FLOW = 'flow';

const readStored = () => {
    try {
        return window.localStorage.getItem(STORAGE_KEY) === VALUE_FLOW;
    } catch {
        return false;
    }
};

/** [isFlow, setFlow] — remembered per browser, always false outside dev. */
export const useFlowLayout = () => {
    const [isFlow, setIsFlow] = useState(() => FLOW_LAYOUT_AVAILABLE && readStored());
    const setFlow = useCallback((next) => {
        setIsFlow(next);
        try {
            window.localStorage.setItem(STORAGE_KEY, next ? VALUE_FLOW : VALUE_PANELS);
        } catch {
            // Private mode: the switch still works for this page view.
        }
    }, []);
    return [FLOW_LAYOUT_AVAILABLE && isFlow, setFlow];
};

const FlowLayoutToggle = ({ value, onChange }) => {
    if (!FLOW_LAYOUT_AVAILABLE) return null;
    return (
        <div className="flow-layout-toggle row">
            <span className="flow-layout-toggle-label">dev · layout</span>
            <Toggle
                variant="pill"
                ariaLabel="Generator layout"
                value={value ? VALUE_FLOW : VALUE_PANELS}
                onChange={(next) => onChange(next === VALUE_FLOW)}
                items={[
                    { value: VALUE_PANELS, label: 'panels' },
                    { value: VALUE_FLOW, label: 'flow' },
                ]}
            />
        </div>
    );
};

export default FlowLayoutToggle;
